export default "__VITE_ASSET__CZT$p5ln__"